import type { ColumnDef } from "@tanstack/react-table";
import { Checkbox } from "@/core/components/ui/checkbox";
import { Stack } from "@/core/components/ui/stack";
import type { PayrollStatementNotificationRecipient } from "@/payroll/pay-breakdown/payroll-statement-notifications/types";
import type { RecipientSelectionColumnOptions } from "./types";

export const SelectCol = ({
  disabled,
  selectedRecipientIds,
  allEligibleSelected,
  someEligibleSelected,
  eligibleRecipientsCount,
  onToggleAllEligible,
  onToggleRecipient,
}: RecipientSelectionColumnOptions): ColumnDef<
  PayrollStatementNotificationRecipient,
  unknown
> => ({
  id: "select",
  enableSorting: false,
  meta: { size: "3.5rem" },
  header: () => (
    <Stack align="center" justify="center" onClick={(e) => e.stopPropagation()}>
      <Checkbox
        checked={allEligibleSelected}
        indeterminate={!allEligibleSelected && someEligibleSelected}
        disabled={disabled || eligibleRecipientsCount === 0}
        onCheckedChange={(checked) => onToggleAllEligible(checked === true)}
        aria-label="Select all technicians"
      />
    </Stack>
  ),
  cell: ({ row }) => {
    const recipient = row.original;
    return (
      <Stack
        align="center"
        justify="center"
        onClick={(e) => e.stopPropagation()}
      >
        <Checkbox
          checked={selectedRecipientIds.has(recipient.technician_id)}
          disabled={disabled || !recipient.eligible}
          onCheckedChange={(checked) =>
            onToggleRecipient(recipient, checked === true)
          }
          aria-label={`Select ${recipient.name}`}
        />
      </Stack>
    );
  },
});
